<script lang="ts" setup>
import { QuizQuestion, UserAnswerStats } from '@/models/quiz-question.model';
import { ShiftCMSState } from '@/store';
import { ContentStoreActions, ContentStoreState } from '@/stores/content.store';
import { computed, onMounted, PropType } from 'vue';
import { useStore } from 'vuex';

const props = defineProps({
  question: {
    type: Object as PropType<QuizQuestion>,
    required: true,
  },
});

const store = useStore<ShiftCMSState & { cns: ContentStoreState }>();

const stats = computed<UserAnswerStats>(() => store.state.cns.questionStats);

onMounted(() => {
  store.dispatch(ContentStoreActions.GetQuizQuestionStats, props.question.id);
});
</script>
<template>
  <v-container>
    <h2>Stats</h2>
    <ul class="stats">
      <li v-for="answer in question.answers" :key="answer.id" class="stat-row">
        <div
          class="stat-score"
          :style.attr="`width: ${
            stats.answerStats.find((s) => s.id === answer.id)?.percentage
          }%`"
        ></div>
        <div class="stat-name">{{ answer.text }}</div>
        <span
          >({{
            stats.answerStats.find((s) => s.id === answer.id)?.answers
          }}
          answer{{
            stats.answerStats.find((s) => s.id === answer.id)?.answers === 1
              ? ''
              : 's'
          }}
          )
          {{
            stats.answerStats.find((s) => s.id === answer.id)?.percentage
          }}%</span
        >
      </li>
    </ul>
  </v-container>
</template>
<style scoped>
.stats {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.stat-row {
  background-color: rgb(182, 182, 182);
  color: white;
  border-radius: 4px;
  margin-bottom: 4px;
  padding: 4px;
  position: relative;
}
.stat-name {
  position: relative;
  z-index: 2;
}

.stat-score {
  border-radius: 4px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  background-color: rgb(122, 169, 90);
}

.stat-row span {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 3;
}
</style>
